import { __assign, __read } from "tslib";
import React from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { noop } from "../_util/noop";
import { useDefault } from "../_util/use-default";
import { CheckContext } from "../check";
import { useConfig } from "../_util/use-config";
export function RadioGroup(_a) {
    var _b;
    var checkValue = _a.value, defaultCheckValue = _a.defaultValue, _c = _a.onChange, onCheckValueChange = _c === void 0 ? noop : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, type = _a.type, block = _a.block, className = _a.className, style = _a.style, children = _a.children;
    var classPrefix = useConfig().classPrefix;
    var _e = __read(useDefault(checkValue, defaultCheckValue, onCheckValueChange), 2), value = _e[0], onChange = _e[1];
    var context = {
        inject: function (checkProps) {
            // 只为 radio 提供
            if (!checkProps.radio) {
                return checkProps;
            }
            // 如果已经受控，则不注入
            if (typeof checkProps.checked === "boolean") {
                return checkProps;
            }
            var checkName = checkProps.name;
            if (typeof checkName === "undefined") {
                console.warn('<Radio> managed by <RadioGroup> must include the "name" prop');
                return checkProps;
            }
            return __assign(__assign({}, checkProps), { type: type,
                block: block, checked: value === checkProps.name, disabled: checkProps.disabled || disabled, onChange: function (checked, context) {
                    if (typeof checkProps.onChange === "function") {
                        checkProps.onChange(checked, context);
                        return;
                    }
                    if (typeof onChange === "function") {
                        onChange(checkName, context);
                    }
                } });
        },
    };
    return (React.createElement(View, { className: classNames(classPrefix + "-checkbox-group", className, (_b = {},
            _b[classPrefix + "-checkbox-group--outline"] = type === "button",
            _b)), style: style },
        React.createElement(CheckContext.Provider, { value: context }, children)));
}
//# sourceMappingURL=RadioGroup.js.map